export const BARCODE_REQUEST = "BARCODE_REQUEST";
export const BARCODE_SUCCESS = "BARCODE_SUCCESS";
export const BARCODE_FAILED = "BARCODE_FAILED";
